var _excluded = ["children", "className", "href", "kind", "tag", "direction"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { rightLinkArrowIcon } from '@lululemon/ecom-pattern-library-icons';
import LinkGenerator from '../link-generator';
import Icon from '../icons';
require("./cta-link.css");
var styles = {
  "ctaLink": "ctaLink-2AamS",
  "ctaLinkPrimary": "ctaLinkPrimary-1jb6a",
  "ctaLinkSecondary": "ctaLinkSecondary-1muFA",
  "ctaLinkContent": "ctaLinkContent-n5vMZ",
  "ctaLinkIcon": "ctaLinkIcon-3XB0n",
  "reverseDirection": "reverseDirection-ZcW_h",
  "left": "left-1tO74"
};
var CTALink = _ref => {
  var {
      children,
      className,
      href,
      kind,
      tag,
      direction
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag || 'a';
  var linkContent = /*#__PURE__*/React.createElement("span", {
    className: styles.ctaLinkContent
  }, children);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    href: href,
    className: cn(styles.ctaLink, className, {
      [styles.ctaLinkPrimary]: kind === 'primary',
      [styles.ctaLinkSecondary]: kind === 'secondary',
      [styles.reverseDirection]: direction === 'left'
    })
  }, rest), direction === 'right' && linkContent, /*#__PURE__*/React.createElement("span", {
    style: {
      whiteSpace: 'nowrap'
    }
  }, "\uFEFF", /*#__PURE__*/React.createElement(Icon, {
    className: cn(styles.ctaLinkIcon, {
      [styles.left]: direction === 'left'
    }),
    content: rightLinkArrowIcon,
    "aria-hidden": "true",
    "data-testid": "link-arrow-icon"
  })), direction === 'left' && linkContent);
};
CTALink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  kind: PropTypes.oneOf(['primary', 'secondary']),
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  /** indicates the direction of the link */
  direction: PropTypes.oneOf(['left', 'right'])
};
CTALink.defaultProps = {
  className: null,
  href: null,
  kind: 'primary',
  tag: LinkGenerator,
  direction: 'right'
};
export default CTALink;